import { useNavigate } from "react-router-dom";
import { Card,
    CardHeader, CardTitle,
    CardBody,
    Button} from "reactstrap"

function NotFoundPage () {
    const navigation = useNavigate();

    return (
        <>
            <div className="content">
                <Card>
                    <CardHeader>
                        <CardTitle tag="h4"></CardTitle>
                    </CardHeader>
                    <CardBody>
                        <div className="typography-line">
                            <h1 className="title">Goodnet</h1>
                            <h6>Halaman Tidak Di Temukan</h6>
                            <p>Kembali ke Halaman Utama.</p>
                            <p>404 Not Found</p>
                            <Button
                                size="lg"
                                className="mb-3 btn-round text-white font-weight-bold bg-dark"
                                onClick={() => navigation('/')}
                            >Kembali</Button>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </>
    )
}

export default NotFoundPage